import { createFileRoute, notFound } from "@tanstack/react-router";
import { ErrorState } from "../components/error-state";
import { creatorPageHead, shellFrom } from "../lib/head";
import { loadErrorPreview } from "../server/previews";

/** The owner's preview of the 404 or 500 page (/preview/errors/:status), from the dashboard. */
export const Route = createFileRoute("/preview/errors/$status")({
  loader: async ({ params }) => {
    const page = await loadErrorPreview({ data: params.status });
    if (!page) throw notFound();
    return page;
  },
  head: ({ matches, loaderData }) => {
    const shell = shellFrom(matches);
    if (!shell || !loaderData) return {};
    return creatorPageHead(shell, {
      pathname: `/preview/errors/${loaderData.status}`,
      title: `${loaderData.status} preview | ${loaderData.creatorName}`,
      description: `Private preview of the ${loaderData.status} error page.`,
    });
  },
  component: ErrorPreview,
});

function ErrorPreview() {
  const { status, creatorName } = Route.useLoaderData();
  return <ErrorState status={status} preview creatorName={creatorName} />;
}
